import { component } from 'picoapp'
import $ from '../lib/quantdom'
import { InfiniteScroll } from '../lib/infinite-scroll'
import { get } from '../lib/ajax'

export default component((node) => {
  function infiniteScrollProductGrid() {
    const url = new URL(window.location)
    const params = url.searchParams
    const totalProducts = parseInt($(node).attr('data-product-count'))
    const productsPerPage = parseInt($(node).attr('data-products-per-page'))
    const totalPages = Math.ceil(totalProducts / productsPerPage)
    params.set('view', 'product-cards')

    window.productScroll = new InfiniteScroll('.js-load-more-btn', () => {
      let currentPage = parseInt(params.get('page')) || 1
      currentPage += 1
      params.set('page', currentPage)

      if (currentPage <= totalPages) {
        get(url)
          .then((res) => {
            const parser = new DOMParser()
            const doc = parser.parseFromString(res, 'text/html')
            const html = doc.querySelector('.js-product-grid').innerHTML
            $('.js-load-more-wrapper').hide(true)
            $('.js-load-more-btn').attr('aria-busy', 'false')
            $(node).append(html)
          })
          .catch((e) => {
            $('.js-load-more-btn').attr('aria-busy', 'false')
            console.log('error', e)
          })
      } else {
        window.productScroll.stop()
      }
    })
  }

  $('.js-load-more-btn').on('click', (e) => {
    e.preventDefault()
    $('.js-load-more-btn').attr('aria-busy', 'true')
    infiniteScrollProductGrid()
  })
})
